import { render } from "./KeywordSearch.vue?vue&type=template&id=683e3c88&scoped=true&ts=true"
import script from "./KeywordSearch.vue?vue&type=script&lang=ts"
export * from "./KeywordSearch.vue?vue&type=script&lang=ts"

import "./KeywordSearch.vue?vue&type=style&index=0&id=683e3c88&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683e3c88"]])

export default __exports__